<template>
  <div v-if="profile">
    <vx-card no-shadow>
      <div class="vx-row mb-6 mt-2">
        <div class="vx-col sm:w-2/5 w-full">
          <h4>Personal information</h4>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="profile.profileImageUrl">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Image</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
         <vs-avatar
              size="large"
              style="object-fit: cover;"
              :src="profile.profileImageUrl"
            />
        </div>
      </div>
      

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Name</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-row class="align-bottom">
            <vs-input
              label="First name"
              class="mr-2"
              v-model="profile.firstName"
            />
            <vs-input
              label="Last name"
              class="mr-2"
              v-model="profile.lastName"
            />
          </vs-row>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Email</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input
            type="email"
            disabled="true"
            :warning="!validateEmail(profile.email)"
            warning-text="E-mail not valid"
            v-model="profile.email"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Phone number</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input
            type="phone"
            :warning="!validatePhone(profile.phone)"
            warning-text="Phone not valid"
            v-model="profile.phone"
          />
        </div>
      </div>

      <!--<div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Gender</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-select width="100px" v-model="profile.gender">
            <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in genders" />
          </vs-select>
        </div>
      </div>-->

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Birthdate</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <datepicker
            :use-utc="true"
            :monday-first="true"
            input-class="vuexy-design"
            placeholder="Select Date"
            v-model="profile.birthDate"
          ></datepicker>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Address</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-row>
            <vs-input
              label="Street and number"
              class="mr-2"
              v-model="profile.street1"
            />
            <vs-input label="Zip code" class="mr-2" v-model="profile.zip" />
            <vs-input label="City" class="mr-2" v-model="profile.city" />
          </vs-row>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Country</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-select width="300px" v-model="profile.country">
            <vs-select-item
              :key="index"
              :value="item"
              :text="item"
              v-for="(item, index) in countries"
            />
          </vs-select>
        </div>
      </div>

      <vs-divider />

      <div class="vx-col lg:w-1/1 w-full">
        <h5 class="mb-6">Segmentation points</h5>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Labels</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-chip :key="idx" v-for="(tag, idx) in profile.labels">
            {{ tag.value }}
          </vs-chip>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Interests</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-col
            class="interest-card mr-5"
            v-for="(tag, idx) in profile.interests"
            :key="idx"
          >
            <div>
              <vx-card>
                <div class="card-header">
                  <vs-row vs-justify="center" class="mb-3">
                    <feather-icon
                      :icon="getInterestIcon(tag.key)"
                      svgClasses="h-5 w-5"
                    />
                  </vs-row>
                  <vs-row vs-justify="center">
                    <strong>
                      {{ tag.key }}
                    </strong>
                  </vs-row>
                </div>
                <vs-row vs-justify="center">
                  {{ tag.value }}
                </vs-row>
              </vx-card>
              <!-- <vs-chip :key="idx" v-for="(tag, idx) in profile.interests">
            {{ tag.key }}: <strong>{{ tag.value }}</strong>
          </vs-chip> -->
            </div>
          </vs-col>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Touchpoints</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-chip :key="idx" v-for="(tag, idx) in profile.touchpoints">
            {{ tag.venueName }} ({{ touchpointSources[tag.source] }})
          </vs-chip>
        </div>
      </div>

      <vs-divider />
      <!-- Save & Remove Button -->
      <vs-row
        vs-justify="space-between"
        class="flex flex-wrap items-center"
        style="margin-top: 32px"
      >
        <vs-button
          id="remove-button"
          @click="confirmRemove"
          color="danger"
          class="mt-2"
          v-if="$AuthService.hasPermission('vp.crm.guestprofiles.edit')"
          >Remove</vs-button
        >
        <vs-button
          id="save-button"
          :disabled="
            !validateEmail(profile.email) && !validatePhone(profile.phone)
          "
          v-if="$AuthService.hasPermission('vp.crm.guestprofiles.edit')"
          @click="update"
          class="mt-2"
          >Save Changes</vs-button
        >
      </vs-row>
    </vx-card>

    <vx-card no-shadow> </vx-card>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import validators from "@/views/mixins/validators";

export default {
  mixins: [validators],
  components: { Datepicker },
  props: {},
  data() {
    return {
      moment,
      profile: null,
      profileId: "",
      genders: ["Male", "Female", "Other", "NoSpecify", "NotSet"],
      countries: ["Denmark", "Norway", "Finland", "United Kingdom"],
      touchpointSources: [
        "Unknown",
        "Web",
        "SMS",
        "Email",
        "Form",
        "Booking",
        "Nightpay",
      ],
    };
  },
  methods: {
    async update() {
      this.$vs.loading();

      try {
        console.log("Updating profile", this.profile);
        await this.$store.dispatch("guestProfiles/update", this.profile);

        this.$vs.notify({
          color: "green",
          title: "Saved",
          text: "Saved",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Could not be saved",
          text: "Could not be saved",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async confirmRemove() {
      console.log(this.profile.interests);
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this?",
        accept: this.remove,
      });
    },
    async remove() {
      this.$vs.loading();
      await this.$store.dispatch("guestProfiles/delete", this.profileId);
      this.$vs.loading.close();
      this.$router.go(-1);
    },
    getInterestIcon(iconName) {
      const interest = this.interests.find((e) => e.name === iconName);
      return interest ? interest.icon : "";
    },
  },
  computed: {
    ...mapGetters({
      interests: "guestSegmentation/interests",
    }),
    displayName() {
      return this.profile.firstName + " " + this.profile.lastName;
    },
    address() {
      return `${this.profile.street1}, ${this.profile.zip} ${this.profile.city}, ${this.profile.country}`;
    },
    phone() {
      return `${this.profile.phoneCountryCode} ${this.profile.phone}`;
    },
  },
  async created() {
    this.$vs.loading();
    this.profileId = this.$route.params.id;
    await this.$store.dispatch("guestProfiles/getGuest", this.profileId, false);
    await this.$store.dispatch("guestSegmentation/get");
    this.profile = this.$store.getters["guestProfiles/profile"](this.profileId);
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
.interest-card {
  min-width: 160px;
  max-width: 160px;

  .vx-card {
    border-top: 4px #ccc solid;
  }
}

.vuexy-design {
  color: inherit;
  position: relative;
  padding: 0.4rem;
  border-radius: 5px;
  padding: 0.7rem !important;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
  box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  width: 100%;
}
.vs-avatar--con-img img {
  object-fit: cover;
}
</style>

<style lang="scss" scoped>
</style>